import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import './notice.css';

class Notice extends Component {
	constructor(props) {
		super(props);
    this.state = {
      data : [],
      graphA: [],
      graphB: [],
      graphC: [],
      graphD: [],
      graphE: [],
      hidden: false,
      headerOpacity: 100,
      animateBarChart: false
    };
    this.toggleNotice = this.toggleNotice.bind(this);
    this.graphBRef = React.createRef();
  }

	componentDidMount() {
    this.getData();
  }

  // Retrieves the list of items from the Express app
  getData = () => {
    fetch('/api/notice')
    .then(res => res.json())
    .then(data=> this.setState({ 
      data: data.data,
      graphA: data.graphA,
      graphB: data.graphB,
      graphC: data.graphC,
      graphD: data.graphD,
      graphE: data.graphE
    }));
  }

  toggleNotice = () => {
  	this.props.toggleNotice()
  }

  handleScroll = (e) => {
  	let element = e.target;
  	let opacity = (1 - (2 * element.scrollTop / element.clientHeight)) / 1;
  	this.setState({
  		headerOpacity: opacity
  	});
  	if (element.scrollTop / element.scrollHeight > .3) { // TODO make graph a component, and animate on load?
  		const graphB = this.graphBRef.current;
  		graphB.classList.add('activated');
  	}
  }

	render() {
    const { data } = this.state;
    const { graphA } = this.state;
    const { graphB } = this.state;
    const { graphC } = this.state;
    const { graphD } = this.state;
    const { graphE } = this.state;
    // const hidden = this.props.hidden ? ' hidden' : null;
    
	  return (
	    <React.Fragment>
	      {data.length ? (
	        <div id="notice" className={`bgBlack fullWidth fullHeight ${this.props.showNotice?'':'hidden'}`} onScroll={this.handleScroll.bind(this)}>
	        	{/* START Intro */}
		        	<div className="noticeHeader" style={{opacity:this.state.headerOpacity}}>
			          <h1 className="gt headerH">So<br/>boom...</h1>
	              <img className="noticeBG" src="/images/globesolo.gif" alt="gray globe"></img>
			        </div>
				      <div className="noticeTop marginTopLarge">
		            <div dangerouslySetInnerHTML={{ __html : data[0].topText }}></div>
			          {/* START Toggle Notice */}
	              <div id="ToggleNotice" className="buttonCTA" onClick={this.toggleNotice}>
	                Show me<br/>the map
	              </div>
			          {/* END Toggle Notice */}
		            <Fade>
			            <div dangerouslySetInnerHTML={{ __html : data[0].smallText }}></div>
			          </Fade>
		          </div>
		        {/* END Intro */}
		        {/* START GraphA */}
		          {graphA.length ? (
		          	<Fade>
			            <table className="graph1 fullStage">
			            	<tbody>
				              <tr className="graphHeader">
				                <th>industry</th>
				                <th>small business employment</th>
				                <th>total private employment</th>
				                <th>small Business employment share</th>
				              </tr>
				              {graphA.map((item, i) => {
				                return(
				                  <tr className="dataRow" key={i+"-items"}>
				                    <td className="titleTd" key={i+"-item1"}>{item.title}</td>
				                    <td className="numberData" key={i+"-item2"}>{item.col1}</td>
				                    <td className="numberData" key={i+"-item3"}>{item.col2}</td>
				                    <td className="numberData" key={i+"-item4"}>{item.col3}%</td>
				                  </tr>
				                )
				              })}
				            </tbody>
			            </table>
			          </Fade>
		          ):("")}
		        {/* END GraphA */}
		        {/* START Middle */}
			        <Fade>
			          <div className="noticeMid fullStage">
			            <div className="fullWidth" dangerouslySetInnerHTML={{ __html : data[0].midText }}></div>
			          </div>
			        </Fade>
	          {/* END Middle */}
	          {/* START Employment */}
		          <Fade>
			          <div className="enterEmploy">
			          	<div className="graphText">
				            <div className="graphTitle" dangerouslySetInnerHTML={{ __html : data[0].g1info }}></div>
				            <div>
				              <div className="note"><span className="graphNote">Note: </span>{data[0].g1note}</div>
				              <div className="source"><span className="graphNote">Source: </span>{data[0].g1source}</div>
				            </div>
			            </div>
					        {/* START GraphB */}
			              {graphB.length ?(
			                <div className="graph2" ref={this.graphBRef}>
			                  {graphB.map((item, i)=>{
			                    return(
			                      <div className={"enterpriseBar flex marginBotTiny " + item.title.split(" ")[0]} key={i+"-graphBItems"}>
			                        <div className="colorBar">
				                        <div className="title" key={i+"-graphBItem1"}>{item.title}</div>
				                        <div className="value" key={i+"-graphBItem2"}>{item.col1}</div>
			                      	</div>
			                      </div>
			                    )
			                  })}
			                </div>
			              ):("")}
					        {/* END GraphB */}
					      </div>
					    </Fade>
				    {/* END Employment */}
			      {/* START Owners */}
				      <Fade>
					      <div className="owners fullStage marginBotLarge">
			            <h4 className="gt">Curious what the business owners look like?</h4>
			            <div className="fullWidth listHold">
				            {graphE.length ? (
				              <table className="graph3">
				              	<tbody>
					                <tr className="graphHeader">
					                  <th className="empty"></th>
				                    <td className="headerHold">
				                    	<table>
				                    		<tbody>
				                    			<tr>
							                      <th className="empty"></th>
							                      <th>Total Employed</th>
							                      <th>Owners</th>
							                      <th>Employees</th>
							                    </tr>
							                  </tbody>
							                </table>
				                    </td>
				                  </tr>
				                  {graphE.map((item, i)=>{
				                    return(
				                      <tr className="dataRow" key={i+"-graphE"}>
				                        <td className="category">{item.cat}</td>
				                        {item.graphItems.length ? (
				                          <td className="subRowHolder">
				                          	<table>
		                              		<tbody>
						                            {item.graphItems.map((row, i) => {
						                              return(
						                                <tr className="subRow" key={"graphEItems-"+i}>
						                                  <td className="subTitle" key={i+"-graphEItemTitle"}>{row.title}</td>
						                                  <td className="numberData" key={i+"-graphEItem1"}>{row.col1}</td>
						                                  <td className="numberData" key={i+"-graphEItem2"}>{row.col2}</td>
						                                  <td className="numberData" key={i+"-graphEItem3"}>{row.col3}</td>
						                                </tr>
						                              )
						                            })}
				                              </tbody>
		                                </table>
				                          </td>
				                        ):("")}
															</tr>
				                    )
				                  })}
				                </tbody>
											</table>
					          ):("")}
				          </div>
								</div>
							</Fade>
						{/* END Owners */}
						{/* START Top 25 */}
							<Fade>
			          <div className="top25">
		              <h2>As of 2019, the 25 biggest businesses in the United States are:</h2>
		              <div className="top25Hold">
		              	<div className="top25List">
			                {graphC.length?(
			                  graphC.map((item,i)=>{
			                    return(
			                      <div className="business" key={i+"-graphC"}>
			                        <h3>{i+1}</h3>
			                        {item.images.length ? (
			                          <div className="businessLogo">
			                            <img src={item.images[0].imgURL} alt={i+"logo"}></img>
			                          </div>
			                        ):("")}
			                        <div className="businessName">{item.title}</div>
			                        <div className="businessLocation">{item.col2}</div>
			                        <div className="businessIndustry">
			                        	{item.col1}
			                        	<span className="businessLabel">Industry</span>
			                        </div>
			                        <div className="businessCEO">
			                        	{item.col3}
			                        	<span className="businessLabel">CEO</span>
			                        </div>
			                        <div className="businessStats">
			                          <div className="businessMV">
			                          	${item.col6}
			                          	<span className="businessLabel">Market Value</span>
			                          </div>
			                        </div>
				                    </div>
			                    )
			                  })
			                ):("")}
			              </div>
		              </div>
			          </div>
			        </Fade>
		        {/* END Top 25 */}
	          {/* START Bottom */}
		          <div className="bottomText marginBotLarge">
  		          <Fade>
		              <div className="fullWidth marginBotLarge" dangerouslySetInnerHTML={{ __html : data[0].bottomText }}></div>
		            </Fade>
	              <table className="industryTable">
	              	<tbody>
		                <tr className="industryLegend">
		                	<th></th>
		                  <th className="industryLabel">industry</th>
		                  <th>GDP added</th>
		                  <th>Total % of GDP</th>
		                </tr>
		                {graphD.length ? (
		                  graphD.map((item,i) => {
		                    return(
			                    <tr className="industryRow" key={i+"-graphD"}>
		                        <td key={"graphDRank-"+i}><span className="industryRank">{i+1}</span></td>
		                        <td className="industry" key={"graphDTitle-"+i}>{item.title}</td>
		                        <td className="numberData" key={"graphDItem1-"+i}>${item.col1}</td>
		                        <td className="numberData" key={"graphDItem2-"+i}>{item.col2}%</td>
			                    </tr>
		                    )
		                  })
			              ):("")}
			            </tbody>
						    </table>
							</div>
	          {/* END Bottom */}
	          <div id="ToggleNotice" className="buttonCTA" onClick={this.toggleNotice}>
              Show me<br/>the map
            </div>
		      </div>
			  ):("")}
			</React.Fragment>
		)
	}
}

export default Notice


// WEBPACK FOOTER //
// ./src/components/strategy/notice/notice.js